/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Password_Forgot_SuccessInputs */

const es_co2_password_forgot_success = /** @type {(inputs: Password_Forgot_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Si tu cuenta es elegible, recibirás instrucciones por correo.`)
};

/**

* @param {Password_Forgot_SuccessInputs} inputs
* @param {{ locale?: "es-CO" }} options
* @returns {LocalizedString}
*/
export const password_forgot_success = /** @type {((inputs?: Password_Forgot_SuccessInputs, options?: { locale?: "es-CO" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Password_Forgot_SuccessInputs, { locale?: "es-CO" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return es_co2_password_forgot_success(inputs)
});